<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { GetSustainabilityRadarData, severityCode } from "@/services/api/chart.api";
import SimpleRadarChart from "@/components/app/charts/SimpleRadarChart.vue";

const props = defineProps({
  partyReference: undefined,
});

const numbers = ref(undefined);

watch(
  () => props.partyReference,
  () => {
    getRadarData();
  },
  { immediate: true }
);

async function getRadarData() {
  const response = await GetSustainabilityRadarData(props.partyReference);
  if (response && response.severity < severityCode.warning) {
    //console.log("Verduurzamingsradar getRadarData, response: ", response);
    numbers.value = [response.data.radarStrategy, response.data.radarInsight, response.data.radarSharedValues, response.data.radarStatus, response.data.radarStrikingPower];
  } else {
    numbers.value = undefined;
  }
}

const chartStyle = computed(() => {
  return {
    width: `350px`,
    height: `350px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});
</script>

<template>
  <div class="widget-item">
    <header>
      <h2>Verduurzamingsradar</h2>
      <div class="widget-actions">
        <information-dropdown>
          <template v-slot:header>
            <h2>Verduurzamingsradar</h2>
          </template>
          <p>
            De Verduurzamingsradar is een bedrijfskundig model. Het doel hiervan is om u én onszelf bewust te maken van de status van de energietransitie binnen uw organisatie, gerelateerd aan de
            Nederlandse klimaatdoelen. Op basis van dit bewustzijn kan worden bepaald of professionalisering is gewenst en hoe dit bewerkstelligd zou kunnen worden.
          </p>
        </information-dropdown>
      </div>
    </header>
    <v-container v-if="numbers != undefined" class="vue-chart vue-sustainability-radar pa-0">
      <v-row>
        <v-col cols="auto">
          <simple-radar-chart :sourceData="numbers" :chartStyle="chartStyle"></simple-radar-chart>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="vue-chart vue-sustainability-radar pa-0">
      <p>Geen gegevens beschikbaar voor deze partij</p>
    </v-container>
  </div>
</template>
